module.exports = __webpack_public_path__ + "static/case_details_02-fad1c41a768b0cedee208a6ecd5f9c52.jpg";